import React from "react";
import { InvoiceLogo } from "../../../../components/logos";
import { useDispatch, useSelector } from "react-redux";
import { setConfirmCloseStaffSessionModalOpen, setEndStaffSessionModalOpen } from "../../../../redux/actions/staffSession/staffSessionAction";
import { ConfirmCloseStaffSession } from "../../../../components/modals/confirmCloseStaffSession";
import { confirmCloseStaffSession } from "../../../../redux/actions/api/apiAction";

export const ConfirmCloseStaffSessionActionButton = ({ staffSessionId, actionType }) => {
  const dispatch = useDispatch();
  const { confirmCloseStaffSessionModalOpen, confirmCloseStaffSessionOpenedID, endSessionModalOpen } = useSelector(state => state.staffSession);

  const handleModalToggle = () => {
    if (actionType == "End") {
      if (endSessionModalOpen) {
        dispatch(setEndStaffSessionModalOpen(false));
      } else {
        dispatch(setEndStaffSessionModalOpen(true, staffSessionId));
      }
    }
    if (actionType == "Confirm") {
      if (confirmCloseStaffSessionModalOpen) {
        dispatch(setConfirmCloseStaffSessionModalOpen(false));
      } else {
        dispatch(setConfirmCloseStaffSessionModalOpen(true, staffSessionId));
      }
    }
  };

  const confirmCloseStaffSessionHandler = (values) => {

    dispatch(confirmCloseStaffSession({
      staffSessionId: confirmCloseStaffSessionOpenedID,
      cashOnSiteConfirmedAmount: values.cashOnSiteConfirmed
    }));
  };
  return (
    <section>
      <div className="c-pointer text-uppercase">
        <div style={{color: `${actionType == "End" ? "var(--danger)" : "var(--success)"}`}} onClick={handleModalToggle} >{actionType}</div>
      </div>
      {
        confirmCloseStaffSessionModalOpen &&
        <ConfirmCloseStaffSession handleSubmit={confirmCloseStaffSessionHandler}/>
      }
    </section>
  );
};
